<div class="organize-team">
  <div class="modal-header organize-team-modal-header">
    <h3 class="modal-title">{{'manage_title'|translate}}</h3>
    <div class="warning-manage-team">
      <span [innerHTML]="('temporar_manage_team_warning' | translate)"></span>
    </div>
    <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" class="modal-close-btn" (click)="close()">
  </div>
  <div class="modal-body">
    <app-organize-teams style="height: 50rem;"></app-organize-teams>
  </div>
</div>
